export const DROPDOWN_SCROLL_MIN_ITEMS = 5;
export const DROPDOWN_MIN_HEIGHT = 200;
